<template>
  <div class="loadingBox" v-if="store.state.loading">
    <a-spin size="large" tip="数据加载中" class="loadingSpan"/>
  </div>
  <router-view/>
  <!-- AI聊天组件 - 只在简历页面显示，使用懒加载 -->
  <component
    :key="isLoginStatus ? 'v1' : 'v0'"
    :is="SuspendedBallChatComponent"
    ref="SuspendedBallChatRef"
    v-if="showChatComponent && SuspendedBallChatComponent && !open"
    :url="apiUrl"
    size="medium"
    :show-avatar="false"
    :align-user-messages-right="true"
    location="right-center"
    :app-name="appName"
    :disable-input="!isLoginStatus"
    :custom-placeholder="aiPanelPlaceholder"
    :domain-name="domainName"
    :enable-streaming="true"
    :context-history-count="12"
    :enable-voice-input="true"
    :enable-context="true"
    :enable-local-storage="true"
    :enable-speech="false"
    :enable-image-upload="false"
    :show-clear-button="true"
    :supported-custom-context="true"
    :title="'AI简历助手'"
    :welcome-config="{
      title: 'Hi,我是你的专属AI助理',
      description: '基于现代AI技术，提供智能对话服务。',
    }"
    :preset-tasks="[
        {
          id: 'features',
          title: '我的简历有哪些不足',
          description: '帮助您快速定位简历的缺陷和不足',
          icon: '✨'
        },
        {
          id: 'funny',
          title: '根据简历信息写一份求职信',
          description: '让AI帮你写一份独特的求职信',
          icon: '📝'
        },
        {
          id: 'tech-help',
          title: '给我一些面试建议',
          description: '根据您的简历信息给予专属建议指导',
          icon: '💻'
        },
      ]"
    :callbacks="callbacks"
    :requestParamProcessor="requestParamProcessorFn"
    :custom-request-config="{
        headers: {
          'X-Custom-Header': 'custom-value',
        },
        requestParamProcessor: requestParamProcessorFn
      }"
  />
    <a-drawer  title="AI模拟面试室———实时智能情绪分析系统" placement="left" :open="open" @close="onClose" :width="'90%'">
      <template #extra>
        <span style="font-size: 13px;">
             <a-switch v-model:checked="store.state.aiautoSpeech" :disabled="!isVip" style="width: 50px;margin-right: 5px;"/>
             自动语音模式
        </span>
      </template>
      <!-- <section class="timeBox">
        <div class="timeBoxLeft"></div>
        <div class="timeBoxRight">
          <video id="videPreview" playsinline autoplay></video><br>
        </div>
      </section> -->
      <div class="ai-box-wrap">
        <div class="ChatPanelComponentBox">
            <div class="unvip-disable-box" @click="goOpenVip" v-if="!isVip">
              <section class="unvip-content">
                <div class="disable-img">
                  <span class="fas fa-lock"></span>
                </div>
                <div class="disable-text">
                  <h3>VIP会员功能</h3>
                  <p>点击<b>开通</b>尊贵会员，体验在线AI面试特权</p>
                </div>
              </section>
            </div>
          <component
          :is="ChatPanelComponent"
          ref="ChatPanelRef"
          v-if="showChatPanelComponent && ChatPanelComponent"
          :url="apiUrl"
          app-name="interviewer"
          :key="isLoginStatus ? 'vv1' : 'vv0'"
          :domain-name="domainName2"
          :disable-input="!isLoginStatus"
          :custom-placeholder="aiPanelPlaceholder"
          :enable-streaming="true"
          :enable-voice-input="true"
          :enable-context="true"
          :enable-local-storage="true"
          :enable-auto-speech="store.state.aiautoSpeech"
          :enable-speech="false"
          :context-history-count="150"
          :max-history-count="100"
          :enable-image-upload="false"
          :show-clear-button="true"
          :show-close-button="false"
          storage-key="ai-chat-panel-history"
          :title="'🟢 AI模拟面试官'"
          :assistant-config="{
            avatar: 'https://luckycola.com.cn/public/imgs/luckycola_Imghub_forever_sZ5zvsVm17565494882477778.jpeg',
            name: '智能助手',
            description: '您的专属AI助手'
          }"
          :announcement-config="{
            type: 'info',
            title: '温馨提示',
            content: 'AI面试官已经查阅了您当前编辑的简历,如果您已经完成了所有面试准备，请告知AI面试官并开始您的模拟面试之旅吧！',
            showIcon: false,
            dismissible: false,
            action: {
              text: '了解更多',
              onClick: () => console.log('查看更多功能')
            }
          }"
          :callbacks="panelCallbacks"
          :requestParamProcessor="requestParamProcessorFn"
          :custom-request-config="{
              headers: {
                'X-Custom-Header': 'custom-value2',
              },
              requestParamProcessor: requestParamProcessorFn
            }"
        />
        <a-empty description="正在加载中,请稍后..." v-else style="margin-top: 100px;"/>
        </div>
        <div class="right-face-box">
          <div class="right-face-tool">
            <FaceDetection v-model:camera-enabled="cameraEnabled" :is-vip="isVip" @onResultCall="onResultCallFn"/>
          </div>
        </div>
      </div>
    </a-drawer>
</template>

<script setup>
import { useStore } from 'vuex'
import { getUserInfosFn, getLoginStatusFn } from '@/utils/common.js'
import { storage } from './utils/storage'
import { onMounted, computed, ref, shallowRef, watch } from 'vue'
// import CompatibleVideoRecorder from '@/utils/videoRecorder'
import { Spin, Drawer, Switch, message, Empty, Modal } from "ant-design-vue"
import { useRoute } from 'vue-router'
import _ from "lodash";
import { encryptParams } from '@/utils/encryption';
import FaceDetection from '@/components/FaceDetection.vue'

const ASpin = Spin
const ASwitch = Switch
const ADrawer = Drawer
const AEmpty = Empty
const store = useStore()
const route = useRoute()
const open = ref(false);
let timer = null
let SuspendedBallChatRef = ref(null)
let ChatPanelRef = ref(null)
const cameraEnabled = ref(false)
// let recorder = null;
window.autoAIMessage = false

watch(() => cameraEnabled.value, (newValue, oldValue) => {
  if (newValue) {
    message.success('实时AI情绪分析已开启');
  } else {
    message.warning('实时AI情绪分析已关闭');
    store.state.userClosedCamera = true; // 用户主动关闭摄像头
  };
});

// 人脸检测实时采集回调
const onResultCallFn = (result) => {
  try {
    // console.log('=== 人脸检测实时数据 ===', result)
    // 生成语义化的中文统计报告（Markdown格式）
    const report = generateEmotionReport(result)
    store.state.userEmotionReport = report;
    // console.log('\n📊 情绪分析报告\n', report)
  } catch (error) {
    console.error('处理人脸检测数据失败:', error)
  }
}

// 生成语义化的中文情绪分析报告（Markdown格式）
const generateEmotionReport = (data) => {
  try {
    const { current, statistics } = data
    const { faceInfo, emotion } = current
    const { emotionStats, totalDetections, emotionPercentages } = statistics
    const emotionNameMap = {
      neutral: '平静',
      happy: '开心',
      sad: '悲伤',
      angry: '愤怒',
      fearful: '恐惧',
      disgusted: '厌恶',
      surprised: '惊讶'
    }
    const topEmotion = Object.keys(emotionStats).reduce((a, b) => emotionStats[a] > emotionStats[b] ? a : b)
    const topThreeEmotions = Object.entries(emotionStats).sort((a, b) => b[1] - a[1]).slice(0, 3).filter(([_, count]) => count > 0)
    let report = `# 🎭 实时情绪分析报告

**生成时间**: ${new Date(current.timestamp).toLocaleString('zh-CN')}

---

`
    report += `## 👤 基本信息

- **年龄**: 约 ${Math.round(faceInfo.age)} 岁
- **性别**: ${faceInfo.gender === 'male' ? '男性' : '女性'}（置信度 ${(faceInfo.genderProbability * 100).toFixed(1)}%）

`
    report += `## 😊 当前情绪状态

当前检测到的主要情绪为 **${emotionNameMap[emotion.emotion]}**，置信度达到 **${(emotion.confidence * 100).toFixed(1)}%**。

### 📈 当前情绪分布详情

| 情绪 | 概率 | 进度条 |
|------|------|--------|
`
    Object.entries(emotion.expressions).forEach(([emo, prob]) => {
      const percentage = (prob * 100).toFixed(1); const barLength = Math.round(prob * 20)
      const bar = '█'.repeat(barLength) + '░'.repeat(20 - barLength)
      report += `| ${emotionNameMap[emo]} | ${percentage}% | ${bar} |\n`
    })
    report += `
## 📊 累计情绪统计分析

已完成 **${totalDetections}** 次情绪检测，累计统计如下：

`
    if (topEmotion && emotionStats[topEmotion] > 0) {
      report += `### 🎯 主要情绪倾向

在整个检测过程中，您表现出的主要情绪是 **${emotionNameMap[topEmotion]}**，占比达到 **${emotionPercentages[topEmotion]}%**（${emotionStats[topEmotion]} 次）。

`
    }
    if (topThreeEmotions.length > 0) {
      report += `### 🏆 情绪排行榜 (Top 3)\n\n`
      topThreeEmotions.forEach(([emo, count], index) => {
        const medal = ['🥇', '🥈', '🥉'][index]
        report += `${medal} **第${index + 1}名**: ${emotionNameMap[emo]} - ${emotionPercentages[emo]}%（${count} 次）\n`
      })
      report += `\n`
    }
    report += `### 📋 详细情绪统计表

| 情绪 | 出现次数 | 占比 | 可视化 |
|------|---------|------|--------|
`
    Object.entries(emotionStats).sort((a, b) => b[1] - a[1]).forEach(([emo, count]) => {
      const percentage = emotionPercentages[emo]; const barLength = Math.round(parseFloat(percentage) / 5)
      const bar = '▓'.repeat(barLength) + '░'.repeat(20 - barLength)
      report += `| ${emotionNameMap[emo]} | ${count} | ${percentage}% | ${bar} |\n`
    })
    report += `---\n\n*报告由 AI 实时情绪分析系统自动生成*\n`
    return report
  } catch (error) {
    console.error('生成情绪报告失败:', error)
    return '# ⚠️ 报告生成失败\n\n无法生成情绪分析报告，请稍后重试。'
  }
}

const onClose = () => {
  open.value = false;
};
// 监听store.state.aiautoSpeech变化
watch(() => store.state.aiautoSpeech, (newValue, oldValue) => {
  if (newValue) {
    message.success('已开启自动语音模式');
  } else {
    message.warning('已关闭自动语音模式');
  }
});

const isVip = computed(() => {
  return store.state.vipData && store.state.vipData.status == 1;
});

const goOpenVip = () => {
  location.href = 'https://luckycola.com.cn/public/dist/#/shopStore';
}

// 懒加载SuspendedBallChat组件
const SuspendedBallChatComponent = shallowRef(null)
let isLoadingComponent = false
const ChatPanelComponent = shallowRef(null)
let isLoadingPanelComponent = false;

// const startVideo = () => {
//   nextTick(() => {
//     const preview = document.getElementById('videPreview');
//     if (!recorder) {
//       recorder = new CompatibleVideoRecorder({
//         videoEl: preview,
//         timeSlice: 1000,
//         ondata: blob => { console.log('chunk size:', blob.size); /* 此处可上传到后台 */ },
//         onstart: () => {
//           console.log('开始录制视频');
//         },
//         onstop: () => { 
//           console.log('结束录制视频');
//         },
//         onunsupported: () => {
//           console.log('当前浏览器不支持视频录制');
//         }
//       });
//     }
//     recorder.start();
//   })
// };

// watch(open, (newValue, oldValue) => {
//   if (newValue) {
//     startVideo();
//   } else {
//     recorder?.stop()
//   }
// })

// 异步加载聊天组件
const loadChatComponent = async () => {
  if (SuspendedBallChatComponent.value || isLoadingComponent) {
    return
  }

  try {
    isLoadingComponent = true
    console.log('开始加载AI聊天组件...')

    // 动态导入组件
    const { SuspendedBallChat } = await import('ai-suspended-ball-chat')
    SuspendedBallChatComponent.value = SuspendedBallChat
    store.state.showAiEvaluation = true;
    console.log('AI聊天组件加载完成')
  } catch (error) {
    console.error('加载AI聊天组件失败:', error)
  } finally {
    isLoadingComponent = false
  }
}

const loadChatPanelComponent = async () => {
  if (ChatPanelComponent.value || isLoadingPanelComponent) {
    return
  }

  try {
    isLoadingPanelComponent = true
    console.log('开始加载AI聊天组件2...');
    // 动态导入组件
    const { ChatPanel } = await import('ai-suspended-ball-chat');
    ChatPanelComponent.value = ChatPanel;
    store.state.showAiInterviewer = true;
    console.log('AI聊天组件2加载完成')
  } catch (error) {
    console.error('加载AI聊天组件失败:', error)
  } finally {
    isLoadingPanelComponent = false
  }
}

// 控制聊天组件显示逻辑 - 只在简历页面显示
const showChatComponent = computed(() => {
  const shouldShow = route.name === 'Resume' && window.innerWidth > 768

  // 当需要显示组件时，懒加载组件
  if (shouldShow && !SuspendedBallChatComponent.value && !isLoadingComponent) {
    loadChatComponent()
  }

  return shouldShow
})

const showChatPanelComponent = computed(() => {
  let shouldShow = route.name === 'Resume' && window.innerWidth > 768 && open.value;
  // 当需要显示组件时，懒加载组件
  if (shouldShow && !ChatPanelComponent.value && !isLoadingPanelComponent) {
    loadChatPanelComponent()
  }
  return shouldShow;
})

const requestParamProcessorFn = (baseParams, customParams) => {
  // console.log('requestParamProcessorFn===>', baseParams, customParams)
  const rawParams = {
    uid: (store.state.userInfos && store.state.userInfos.userid) || '',
    ...baseParams,
    ...customParams,
    resumeDataJson: getAIResumeData('JSON'),
    resumeDataHTML: getAIResumeData('HTML'),
    userEmotionReport: store.state.userEmotionReport || ''
  };
  
  // 使用加密工具处理参数，自动加密敏感字段并添加_encrypted_fields标识
  return encryptParams(rawParams);
}

const getAIResumeData = (type = 'JSON') => {
  try {
    if (type === 'HTML') {
      // 获取id为tpl_box的元素
      const tplBox = document.getElementById('tpl_box') || {}
      // 去除img标签
      let htmlStr = tplBox.innerHTML
      if (htmlStr) {
        // 去除img标签
        htmlStr = htmlStr.replace(/<img[^>]*>/g, '')
        // 去除base64图片
        htmlStr = htmlStr.replace(/data:image\/[^;]+;base64[^"]+/g, '')
      }
      if (htmlStr) {
        return htmlStr
      }
    } else {
      // 深拷贝
      // let removeAvatar = JSON.parse(JSON.stringify(store.state.selectedResumeTemplate || {}))
      let removeAvatar = _.cloneDeep(store.state.selectedResumeTemplate || {})
      // console.log('removeAvatar', removeAvatar, removeAvatar.basicInfo.avatar)
      if (removeAvatar && removeAvatar.basicInfo && removeAvatar.basicInfo.avatar) {
        removeAvatar.basicInfo.avatar = '省略'
      }
      let jsonStr = JSON.stringify(removeAvatar)
      return jsonStr
    }
  } catch (error) {
    console.log('error', error)
    return ''
  }
}

// AI聊天组件配置
const apiUrl = 'https://luckycola.com.cn/resume/aiResumeAssistant'
const isLoginStatus = computed(() => {
  return !(!store.state.isLogin || !store.state.userInfos.userid);
});

let domainName = computed(() => {
  try {
    if (isLoginStatus.value) {
      const user_id = store.state.userInfos?.userid || '-uid';
      return 'ai-resume-' + user_id;
    } else {
      return 'ai-resume-default';
    }
  } catch (error) {
    return 'ai-resume-error';
  }
});

let domainName2 = computed(() => {
  try {
    if (isLoginStatus.value) {
      const user_id = store.state.userInfos?.userid || '-uid2';
      return 'ai-interviewer-' + user_id;
    } else {
      return 'ai-interviewer-default';
    }
  } catch (error) {
    return 'ai-interviewer-error';
  }
});

let aiPanelPlaceholder = computed(() => {
  if (!isLoginStatus.value) {
    return '登录后可发送消息';
  }
  return '请输入您的问题...';
})

// evaluation interviewer assistant
let appName = ref('assistant')

const callbacks = {
  onUserMessage: (message) => {
    console.log('用户发送消息:', message)
  },
  onAssistantMessage: (message) => {
    // console.log('AI助手回复:', message)
  },
  onStreamData: (data) => {
    // console.log('流式数据:', data)
  },
  onError: (error) => {
    console.error('聊天发生错误:', error)
  }
}

const panelCallbacks = {
  onUserMessage: (message) => {
    console.log('用户发送消息2:', message);
    if (isVip.value && !store.state.userClosedCamera && !cameraEnabled.value) {
      // 先用弹窗提示
      Modal.confirm({
        title: '温馨提示',
        content: 'AI面试官为了更加全面了解您,请求开启您的摄像头录制~',
        okText: '同意',
        cancelText: '拒绝',
        onOk () {
          cameraEnabled.value = true;
        },
        onCancel () {
          store.state.userClosedCamera = true;
        }
      });
    };
  },
  onAssistantMessage: (message) => {
    // console.log('AI助手回复:', message)
    // 内容中包含“面试”“结束/完成”字样
    if (message && (message.includes('稍等') || message.includes('稍候')) && message.includes('面试') && message.includes('已') && (message.includes('结束') || message.includes('完成'))) {
      if (window.autoAIMessage) return; // 防止重复触发
      window.autoAIMessage = true;
      console.log('检测到面试结束指令,准备发送后续消息...');
      // 面试结束 主动给AI发送消息,主动触发下一个流程
      setTimeout(() => {
        ChatPanelRef.value && ChatPanelRef.value.sendMessage('好的');
        setTimeout(() => {
          window.autoAIMessage = false;
        }, 1000 * 60 * 10); // 10分钟后重置
      }, 2000);
    }
  },
}

// 优化：将用户信息获取改为非阻塞
const preGetUserinfo = (isPageShow = false) => {
  // 只在需要显示loading时才显示
  if (isPageShow) {
    store.state.loading = true
  }

  // 设置超时保护，避免无限loading
  setTimeout(() => {
    if (store.state.loading) {
      store.state.loading = false
    }
  }, 10000) // 10秒超时

  getLoginStatusFn((islogin) => {
    if (islogin) {
      getUserInfosFn(() => {
        store.state.loading = false
      })
    } else {
      store.state.loading = false
      store.state.isLogin = false
      storage.set('login_status', {
        status: 0,
        userid: '',
        username: ''
      })
    }
  })
}

const handleEvaluationResume = (params) => {
  // 处理评估简历的逻辑
  if (SuspendedBallChatRef.value) {
    SuspendedBallChatRef.value.openPanel()
    appName.value = 'evaluation'
    setTimeout(() => {
      SuspendedBallChatRef.value.sendMessage('请评估我的简历,生成《评估报告》')
      setTimeout(() => {
        appName.value = 'assistant'
      }, 3000)
    }, 500)
  }
}

const handleAISendEmail = (params) => {
  // 处理AI发送邮件的逻辑
  if (SuspendedBallChatRef.value) {
    SuspendedBallChatRef.value.openPanel()
    appName.value = 'assistant'
    setTimeout(() => {
      SuspendedBallChatRef.value.sendMessage('将我的简历附件(已上传)投递到以下这个邮箱:' + params.targetEmail)
    }, 1000)
  }
}

// 优化：延迟执行用户信息获取，不阻塞页面渲染
onMounted(() => {
  // 延迟1秒执行用户信息获取，让页面先渲染
  setTimeout(() => {
    preGetUserinfo(true);
    if (window.$Bus) {
      window.$Bus.on('evaluationResume', (params) => {
        handleEvaluationResume(params);
      });
      window.$Bus.on('aiSendEmail', (params) => {
        handleAISendEmail(params);
      });
      window.$Bus.on('toggleChatPanel', (params) => {
        open.value = !open.value;
        if (open.value && store.state.resetAIinterviewer) {
          // 等待组件渲染完成后再执行清空操作
          setTimeout(() => {
            if (ChatPanelRef.value) {
              ChatPanelRef.value.clearHistory()
              store.state.resetAIinterviewer = false
            }
          }, 300);
        }
      });
    }
  }, 1000)
  try {
    // 有用户交互后再设置 beforeunload
    window.onbeforeunload = (e) => {
      e = e || window.event             
      if (e) {
        e.returnValue = '关闭提示'
      }
      toCloseFun() // 调用自己的方法
      // Chrome, Safari, Firefox 4+, Opera 12+ , IE 9+
      return '关闭提示'
    }
  } catch (error) {
    console.error('Error setting up user interaction listener:', error);
  }
})

const toCloseFun = (event) => {
}

// 优化：简化页面可见性变化处理
document.addEventListener("visibilitychange", function () {
  if (document.visibilityState === 'visible') {
    if (timer || store.state.loading) return;
    let userStoreObj = storage.get('login_status') || {};
    if ((!store.state.isLogin || !store.state.userInfos.username) && userStoreObj && userStoreObj.userid) {
      timer = setTimeout(() => {
        preGetUserinfo();
        timer = null;
      }, 1000);
    } else if ((store.state.isLogin || store.state.userInfos.username) && (!userStoreObj || !userStoreObj.userid)) {
      timer = setTimeout(() => {
        preGetUserinfo();
        timer = null;
      }, 1000);
    }
  }
})

</script>

<style lang="less">
// @import url('https://kit-pro.fontawesome.com/releases/v5.15.1/css/pro.min.css');
// @import url('https://cdn.bootcdn.net/ajax/libs/reseter.css/2.0.0/minireseter.css');
.loadingBox {
  @apply top-0 left-0 w-screen h-screen bg-red-400;
  position: fixed;
  z-index: 9999999;
  background: rgba(255, 255, 255, 0.3);
  .loadingSpan {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}
* {
  scrollbar-width: none; /* Firefox */
  padding: 0;
  margin: 0;
  list-style-type: none;
  text-decoration: none;
}
.ant-message .anticon {
  top: -2px;
}
.ai-box-wrap {
  display: flex;
  height: 100%;
  .right-face-box {
    // 移动端
    @media (max-width: 768px) {
      display: none;
    }
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    // background: red;
    .right-face-tool {
      // background: green;
      background: rgb(99, 99, 99);
      width: 45vw;
      padding: 5px;
      border-radius: 8px;
      max-width: 700px;
      max-height: 700px;
      height: 84vh;
    }
  }
}

.ChatPanelComponentBox {
  height: 100% !important;
  width: 500px !important;
  display: flex !important;
  flex-direction: column !important;
  /* 调试样式 - 临时添加明显的背景色 */
  background-color: #ffffff !important;
  border: 1px solid #c7c7c7 !important;
  position: relative;
  .unvip-disable-box {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.8);
    z-index: 999999;
    cursor: pointer;
    .unvip-content {
      position: absolute;
      width: 340px;
      height: 200px;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      color: #b9b9b9;
      text-align: center;
      .disable-img {
        font-size: 65px;
      }
      .disable-text {
        h3 {
          font-size: 24px;
          margin-bottom: 5px;
        }
        p {
          font-size: 14px;
          b {
            color: #fe9220;
            padding: 0 2px;
            cursor: pointer;
            &:hover {
              text-decoration: underline;
            }
          }
        }
      }
    }
  }
  .scroll-to-bottom-button {
    bottom: 100px !important;
  }
  
  /* 增强深度选择器，确保能穿透到组件内部 */
  :deep(.ant-drawer-body) {
    padding-top: 0px !important;
    padding-left: 0px !important;
    padding-right: 0px !important;
    padding-bottom: 0px !important;
  }
  
  /* 确保ChatPanel组件内部样式正确应用 */
  :deep(.chat-panel) {
    height: 100% !important;
    width: 100% !important;
  }
  
  :deep(.chat-container) {
    height: 100% !important;
    width: 100% !important;
  }
}
.timeBoxRight {
  width: 100px;
  position: fixed;
  border-radius: 10px;
  border: 3px solid red;
  z-index: 999999;
  .videPreview {
    width: 100%;
  }
}
</style>
